import Player from './player.js';

const PlayerComponent = {
  mounted() {
    console.log('PlayerComponent mounted');
    this.player = new Player(this)
    this.handleEvent("restart_player", () => {
      this.player.destroy()
      this.player = null;
      this.player = new Player(this)
    })
  },
  disconnected() { console.log('PlayerComponent disconnected') },
  reconnected()  { console.log('PlayerComponent reconnected') },
  updated()      { console.log('PlayerComponent updated') },
  destroyed()    {
    console.log('PlayerComponent before destroy');
    this.player.destroy()
    this.player = null
  },

}

export default { PlayerComponent }
